/**
 * Mirrors backend `getPremiumAddonEligibility` `canUpgrade` (backend/routes/membership.js).
 * Use before calling `fetchPremiumAddonQuote` / create-premium-addon-order dry run to avoid
 * expected 400 `invalid_state` for mentors, students, pro-only, etc.
 */
export function membershipAllowsPremiumAddonQuote(msData) {
  if (!msData || typeof msData !== 'object') return false;
  const m = msData.membership;
  /** Backend may clear `applied` before root `hasPremiumAddon` syncs — treat explicit `applied: false` as no add-on. */
  if (m?.premiumAddon?.applied === true) return false;
  if (msData.hasPremiumAddon === true && m?.premiumAddon?.applied !== false) return false;
  if (!m || m.premiumAddon?.applied) return false;
  const st = (m.status || '').toString().toLowerCase();
  const statusOk = st === 'active' || st === 'trialing';
  // Status API sometimes exposes access via allowed / isActive while status string lags after Artmo redeem.
  if (!statusOk && !(m.isActive === true || msData.allowed === true)) return false;
  const tier = (m.tier || m.planTier || '').toString().toLowerCase();
  const planId = (m.planId || '').toString().toLowerCase();
  const isArtmo =
    tier === 'artmocode' ||
    planId === 'artmocode' ||
    m.accessSource === 'artmocode';
  const isActiveBase =
    (tier === 'base' || tier === 'basic' || planId === 'base' || planId === 'basic') &&
    (statusOk || m.isActive === true || msData.allowed === true);
  const pendingPremium = msData.studioOnboardingPhase === 'pending_premium_choice';
  return pendingPremium || isArtmo || isActiveBase;
}
